sn-faq-type-2 {
  .me-container {
    padding-top: 0;

    @include desktop-lg {
      padding-bottom: $spacing-7xl;
    }
  }

  .faq-type-2 {
    // Replace full border with top/bottom separators, remove horizontal padding
    .faq-type-2__item {
      border: none;
      border-top: var(--border-size-sm) solid var(--border-color-primary);
      padding-left: 0;
      padding-right: 0;

      &.faq-type-2__item {
        padding-left: 0;
        padding-right: 0;

        @include desktop {
          padding-left: 0;
          padding-right: 0;
        }
      }

      &:last-child {
        border-bottom: var(--border-size-sm) solid var(--border-color-primary);
      }
    }
  }

  .faq-type-2__header {
    text-align: left;
    margin-left: 0;
    margin-right: 0;
  }

  // Help line ("Need help? Contact support") rendered under the description.
  // Projected into the generic faq-type-2 header via the action-primary slot.
  // NOTE: the root selector here is the element `sn-faq-type-2`, so these must be
  // explicit class selectors (not `&__help`, which would build an element selector).
  .sn-faq-type-2__help {
    margin: var(--spacing-md) 0 0;
    font-size: 16px;
    line-height: 24px;
    color: var(--text-color-primary);
  }

  .sn-faq-type-2__help-inner {
    font-weight: 700;
  }

  .sn-faq-type-2__help-link {
    position: relative;
    display: inline-flex;
    align-items: center;
    color: var(--color-brand-primary, #0777cf);
    font-weight: 700;
    text-decoration: none;

    &::after {
      content: '';
      width: 16px;
      height: 17px;
      margin-left: 8px;
      background: url('https://marketing-static.signnow.com/386/images/global/link-arrow.svg') no-repeat center;
      background-size: contain;
    }

    &:focus-visible {
      outline: 2px solid var(--color-brand-primary, #0777cf);
      outline-offset: 2px;
      border-radius: var(--radius-size-sm);
    }

    // Sliding underline on hover, mirroring sn-comparison-type-2__price-link.
    @include desktop {
      &::before {
        content: '';
        position: absolute;
        right: 0;
        bottom: -3px;
        width: 0;
        height: 2px;
        background: var(--color-brand-primary, #0777cf);
        transition: width 0.15s ease;
        will-change: width;
      }

      &:hover::before {
        left: 0;
        width: 100%;
      }
    }

    @include below-desktop {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .faq-type-2__footer {
    text-align: left;
    margin-left: 0;
    margin-right: 0;
  }

  .faq-type-2__accordion {
    max-width: 100%;
    gap: 0;
  }
}
